// extracted by mini-css-extract-plugin
export default {"list":"OrderedProducts_list__bELNl","title":"OrderedProducts_title__dd+kl","product":"OrderedProducts_product__aGf62"};